import {findConflicts} from '../../../ag-common/tools/dates'

const isString = input => typeof input === 'string' || input instanceof String

const handleClickOutside = (event, thisRef, closeDialogMethod) => {
  if (
    !containsParentElementInTree(thisRef, event.target) &&
    !containsParentElementInTreeWithClass('ReactModalPortal', event.target)
  ) {
    closeDialogMethod()
  }
}

const containsParentElementInTree = (element, treeStart) => {
  let current = treeStart
  while (current) {
    if (current === element) {
      return true
    }
    current = current.parentNode
  }
  return false
}

const containsParentElementInTreeWithClass = (className, treeStart) => {
  let current = treeStart
  while (current) {
    if (current.className && isString(current.className) && current.className.includes(className)) {
      return true
    }
    current = current.parentNode
  }
  return false
}

const doesConflictExist = (start, end, termine) => {
  const mappedTermine = termine.map(({from, to, ...t}) => ({...t, from: new Date(from), to: new Date(to)}))
  return {
    ausbilderTerminConflict: findConflicts(start, end, mappedTermine).filter(t => t.isAusbilderTermin).length > 0,
    azubiTerminConflict: findConflicts(start, end, mappedTermine).filter(t => !t.isAusbilderTermin).length > 0,
  }
}

const doesConflictExistForAusbilder = (start, end, termine) => {
  const mappedTermine = termine.map(({from, to, ...t}) => ({...t, from: new Date(from), to: new Date(to)}))
  return {
    ausbilderTerminConflict: findConflicts(start, end, mappedTermine).filter(t => t.isAusbilderTermin).length > 0,
    azubiTerminConflict: findConflicts(start, end, mappedTermine).filter(t => !t.isAusbilderTermin).length > 0,
    gruppenTerminConflict: findConflicts(start, end, mappedTermine).filter(t => t.gruppenId).length > 0,
  }
}

const DialogLogic = {
  handleClickOutside,
  containsParentElementInTree,
  doesConflictExist,
  doesConflictExistForAusbilder,
}

export default DialogLogic
